<template>
  <div>订单</div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>

</style>
